import React, { useState } from "react";

const servicesData = [
  {
    title: "Custom Web-Based Software Development",
    image:
      "https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=800&q=80",
    short: "Scalable & secure web-based business solutions.",
    details:
      "We design and develop scalable, secure, and fully customized web-based software aligned with your business workflows. Our solutions focus on performance, usability, and long-term maintainability for growing enterprises.",
  },
  {
    title: "Business Process Automation",
    image:
      "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&w=800&q=80",
    short: "Automate operations and reduce manual work.",
    details:
      "We help organizations streamline operations by automating complex business processes and reducing manual dependency, improving efficiency, accuracy, and decision-making across departments.",
  },
  {
    title: "ERP Systems Development",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80",
    short: "Integrated ERP solutions for enterprises.",
    details:
      "Our ERP solutions integrate operations, finance, inventory, and HR into a unified platform that adapts seamlessly to your organization’s evolving needs.",
  },
  {
    title: "Android Application Development",
    image:
      "https://images.unsplash.com/photo-1607252650355-f7fd0460ccdb?auto=format&fit=crop&w=800&q=80",
    short: "High-performance Android apps.",
    details:
      "We develop secure, intuitive, and high-performance Android applications optimized for real-world business use cases and enhanced user engagement.",
  },
];

const coursesData = [
  {
    title: "Android Development",
    image:
      "https://images.unsplash.com/photo-1607252650355-f7fd0460ccdb?auto=format&fit=crop&w=800&q=80",
    short: "Learn Android app development using Java & Kotlin.",
    details:
      "This course covers Android fundamentals including Activities, Fragments, UI/UX design with XML, Material Design, API integration, Firebase authentication, real-time database, notifications, and Play Store deployment.",
  },
  {
    title: "MERN Stack",
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=800&q=80",
    short: "Build scalable full-stack web applications.",
    details:
      "Learn full-stack development using MongoDB, Express.js, React.js, and Node.js with real-time projects, authentication, and deployment.",
  },
  {
    title: "Java Full Stack",
    image:
      "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?auto=format&fit=crop&w=800&q=80",
    short: "Master Java with modern backend frameworks.",
    details:
      "Covers Core Java, OOP, Collections, JDBC, Hibernate, Spring Boot, REST APIs, MySQL, and frontend basics with real-world projects.",
  },
  {
    title: "Python Full Stack",
    image:
      "https://images.unsplash.com/photo-1526379095098-d400fd0bf935?auto=format&fit=crop&w=800&q=80",
    short: "Develop dynamic web applications using Python.",
    details:
      "Covers Python, Django/Flask, REST APIs, database integration, authentication, and deployment for full-stack development roles.",
  },
];

function Services() {
  const [selectedItem, setSelectedItem] = useState(null);

  return (
    <>
      <section className="bg-[#0B1D26] py-20">
        <div className="text-center mb-14">
          <h1 className="text-3xl font-bold text-white">
            Services We Provide
          </h1>
          <p className="mt-2 text-gray-300">
            Enterprise-grade digital solutions tailored to your business
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6">
          {servicesData.map((service, index) => (
            <div
              key={index}
              className="group relative h-96 w-72 cursor-pointer overflow-hidden rounded-xl shadow-lg"
            >
              <img
                src={service.image}
                alt={service.title}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
              />

              <div className="absolute inset-0 bg-black/70"></div>

              <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
                <h2 className="text-xl font-bold text-white">
                  {service.title}
                </h2>
                <p className="mt-2 text-sm text-gray-200">
                  {service.short}
                </p>
                <button
                  onClick={() => setSelectedItem(service)}
                  className="mt-4 rounded bg-white px-4 py-2 text-sm font-semibold text-black"
                >
                  See More
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#0B1D26] pb-20">
        <div className="text-center mb-14">
          <h1 className="text-3xl font-bold text-white">
            Full Stack Courses with Industrial Training
          </h1>
          <p className="mt-2 text-gray-300">
            Job-oriented courses with real-world projects & expert mentorship
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6">
          {coursesData.map((course, index) => (
            <div
              key={index}
              className="group relative h-96 w-72 cursor-pointer overflow-hidden rounded-xl shadow-lg"
            >
              <img
                src={course.image}
                alt={course.title}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
              />

              <div className="absolute inset-0 bg-black/70"></div>

              <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
                <h2 className="text-2xl font-bold text-white">
                  {course.title}
                </h2>
                <p className="mt-2 text-sm text-gray-200">
                  {course.short}
                </p>
                <button
                  onClick={() => setSelectedItem(course)}
                  className="mt-4 rounded bg-white px-4 py-2 text-sm font-semibold text-black"
                >
                  See More
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>


      {selectedItem && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
          <div className="relative w-[90%] max-w-lg rounded-xl bg-white p-6 shadow-xl">
            <button
              onClick={() => setSelectedItem(null)}
              className="absolute top-3 right-4 text-2xl font-bold text-gray-500 hover:text-black"
            >
              ×
            </button>

            <h2 className="mb-3 text-2xl font-bold text-gray-800">
              {selectedItem.title}
            </h2>

            <img
              src={selectedItem.image}
              alt={selectedItem.title}
              className="mb-4 h-48 w-full rounded-lg object-cover"
            />

            <p className="text-gray-700">
              {selectedItem.details}
            </p>

            <div className="mt-5 text-right">
              <button
                onClick={() => setSelectedItem(null)}
                className="rounded bg-black px-5 py-2 text-white"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Services;
